export const HTTP_OK = 200;
export const HTTP_ACCEPTED = 202;
export const HTTP_BAD_REQUEST = 400;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_NOT_ACCEPTABLE = 406;
export const HTTP_CONFLICT = 409;
export const HTTP_UNPROCESSABLE_CONTENT = 422;
export const HTTP_INTERNAL_ERROR = 500;

export const PERMISSION_USERS = 'users';
export const PERMISSION_ROLES = 'roles';
export const PERMISSION_CONTACTS = 'contacts';
export const PERMISSION_PARTNER_ORGANIZATIONS = 'organizations';
export const PERMISSION_OWNED_ORGANIZATIONS = 'owned-organizations';
export const PERMISSION_CALENDAR = 'calendar';
export const PERMISSION_PROJECTS = 'projects';
export const PERMISSION_LEADS = 'opportunities';
export const PERMISSION_FILES = 'files';
export const PERMISSION_TICKETS_USER = 'submit-tickets';
export const PERMISSION_TICKETS_ADMIN = 'tickets';
